import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  static get values() {
    return {
      selector: String,
      triggers: String
    };
  }
  connect() {
    if (!this.selectorValue || !this.triggersValue) {
      return;
    }
    this.triggeringInput = document.querySelector(this.selectorValue);
    if (!this.triggeringInput) {
      return;
    }
    this.triggersList = this.triggersValue.split(" ");
    this._changeListenerProxy = this.onValueChange.bind(this);
    this.triggeringInput.addEventListener("change", this._changeListenerProxy);
    this.onValueChange();
  }
  disconnect() {
    if (this.triggeringInput) {
      this.triggeringInput.removeEventListener("change", this._changeListenerProxy);
    }
    Reflect.deleteProperty(this, "triggeringInput");
    Reflect.deleteProperty(this, "triggersList");
    Reflect.deleteProperty(this, "_changeListenerProxy");
  }
  onValueChange() {
    if (this.triggersList.includes(this.triggeringInput.value)) {
      this.element.classList.remove("hide");
    } else {
      this.element.classList.add("hide");
    }
  }
}
